import type { ProjectBreadcrumbProps } from "./project-breadcrumb.type";

import AncestorsBreadcrumb from "@/modules/ancestors/ancestors-breadcrumb";

import { getProjectBreadcrumbItems } from "./project-breadcrumb.helper";

const ProjectBreadcrumb = ({ project, ...options }: ProjectBreadcrumbProps) => {
  const ancestors = getProjectBreadcrumbItems(project);

  return <AncestorsBreadcrumb {...options} ancestors={ancestors} />;
};

export default ProjectBreadcrumb;
